<app-navbar></app-navbar>

<section class="min-h-[40dvh] bg-black text-black">
    <div class="w-full">
        <div class="min-h-[40dvh] bg-no-repeat bg-cover bg-center relative" style="background-image: url(/assets/img/electric_car_type/65a7e8439510ec682f91d67b_BG_ElectricCar.webp);">
            <div class="absolute inset-0 bg-gradient-to-b from-black/60 to-black/90"></div>
            <div class="text-white relative z-10 max-w-full 2xl:max-w-[70dvw] mx-auto">
                <div class="grid grid-cols-1 xl:grid-cols-4 gap-1">
                    <div class="hidden xl:block">
                        <img src="/assets/img/electric_car_type/67321893e68b0b3e670b7c3c_arrow-green-p-500-left.png" class="w-full animate-fade-left animate-delay-500 animate-once" alt="">
                    </div>
                    <div class="col-span-2">
                        <div class="pt-28 max-w-7xl mx-auto text-center p-8">
                            <div class="justify-center items-center mx-auto">
                                <img src="/assets/img/electric_car_type/6579d143429115628804a525_Electric.svg" alt="tuvsud-image" srcset="" class="w-24 h-24 mx-auto mb-4 animate-fade animate-delay-600 animate-once" />
                                <p class="text-2xl font-bold uppercase">{{texts.title}}</p>
                                <p class="mt-5 text-base">{{texts.description}}</p>
                                <p class="mt-5 text-base">{{texts.subtitle}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="hidden xl:block">
                        <img src="/assets/img/electric_car_type/67321893e68b0b3e670b7c3c_arrow-green-p-500.png" class="w-full animate-fade-right animate-delay-500 animate-once" alt="">
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    <div class="bg-black w-full">
        <div class="container mx-auto text-white mt-8">
            <div class="w-full md:w-3/5 lg:w-4/5 mx-auto">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div class="overflow-hidden text-white bg-black rounded m-4 p-12">
                    <!--  Image -->
                        <figure class="bg-white rounded">
                            <a href="/tires/product/xnex-sport-ev" routingLink="/tires/product/xnex-sport-ev">
                                <img src="/assets/img/tire_search/659e71601ccc97ccc4f898a4_xnex-tireonwheel.webp" alt="card image" class="w-full rounded border-2 border-green-500" />
                            </a>
                        </figure>
                        <!-- Body-->
                        <div class="p-6">
                            <header>
                                <a href="/tires/product/xnex-sport-ev" routingLink="/tires/product/xnex-sport-ev">
                                    
                                    <h3 class="flex text-2xl font-medium uppercase">{{texts.xnex.title}}<span class="ml-3"><img src="/assets/img/electric_car_type/65704562004ba1048b0b5e46_open.svg" alt="" class="w-5 h-6" srcset=""></span> </h3>
                                </a>
                                <p class="text-lg">{{texts.xnex.description}}</p>
                                <div class="grid grid-cols-4 gap-2 mt-4 text-center">
                                    <div class="mx-auto items-center justify-center">
                                        <img src="/assets/img/electric_car_type/Inktech.svg" alt="inktech" class="w-6 rounded mx-auto" />
                                        <p class="text-xs">Inktech</p>
                                    </div>
                                    <div class="mx-auto items-center justify-center">
                                        <img src="/assets/img/electric_car_type/Healteck.svg" alt="healteck" class="w-6 rounded mx-auto" />
                                        <p class="text-xs">Healteck</p>
                                    </div>
                                    <div class="mx-auto items-center justify-center">
                                        <img src="/assets/img/electric_car_type/Silenteck.svg" alt="silenteck" class="w-6 rounded mx-auto" />
                                        <p class="text-xs">Silenteck</p>
                                    </div>
                                    <div class="mx-auto items-center justify-center">
                                        <img src="/assets/img/electric_car_type/XL.svg" alt="XL" class="w-6 rounded mx-auto" />
                                        <p class="text-xs">XL</p>
                                    </div>
                                    
                                </div>
                            </header>
                        </div>
                    </div>

                    <div class="overflow-hidden text-white bg-black rounded m-4 p-12">
                    <!--  Image -->
                        <figure class="bg-white rounded">
                            <a href="/tires/product/xlab-comfort-ev" routingLink="/tires/product/xlab-comfort-ev">
                                <img src="/assets/img/tire_search/659e7b4e096a248e64f88362_xlab-tireonwheel.webp" alt="card image" class="w-full rounded border-2 border-green-500" />
                            </a>
                        </figure>
                        <!-- Body-->
                        <div class="p-6">
                            <header>
                                <a href="/tires/product/xlab-comfort-ev" routingLink="/tires/product/xlab-comfort-ev">
                                    <h3 class="flex text-2xl font-medium uppercase">{{texts.xlab.title}}<span class="ml-3"><img src="/assets/img/electric_car_type/65704562004ba1048b0b5e46_open.svg" alt="" class="w-5 h-6" srcset=""></span> </h3>
                                </a>
                                <p class="text-lg">{{texts.xlab.description}}</p>
                                <div class="grid grid-cols-4 gap-2 mt-4 text-center">
                                    <div class="mx-auto items-center justify-center">
                                        <img src="/assets/img/electric_car_type/Inktech.svg" alt="inktech" class="w-6 rounded mx-auto" />
                                        <p class="text-xs">Inktech</p>
                                    </div>
                                    <div class="mx-auto items-center justify-center">
                                        <img src="/assets/img/electric_car_type/Healteck.svg" alt="healteck" class="w-6 rounded mx-auto" />
                                        <p class="text-xs">Healteck</p>
                                    </div>
                                    <div class="mx-auto items-center justify-center">
                                        <img src="/assets/img/electric_car_type/Silenteck.svg" alt="silenteck" class="w-6 rounded mx-auto" />
                                        <p class="text-xs">Silenteck</p>
                                    </div>
                                    <div class="mx-auto items-center justify-center">
                                        <img src="/assets/img/electric_car_type/XL.svg" alt="XL" class="w-6 rounded mx-auto" />
                                        <p class="text-xs">XL</p>
                                    </div>
                                    
                                </div>
                            </header>
                        </div>
                    </div>

                </div>
            </div>
            

        </div>
    </div>
</section>

<app-footer></app-footer>